import { theme } from '@chakra-ui/react';

export const fontSizes = {
  ...theme.fontSizes,
  '2xs': '0.625rem',
  '3xs': '0.5rem',
};
